var render, staticRenderFns
import script from "./PanduanFiturBaru.vue?vue&type=script&lang=js&"
export * from "./PanduanFiturBaru.vue?vue&type=script&lang=js&"
import style0 from "./PanduanFiturBaru.vue?vue&type=style&index=0&id=55232492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports